var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Guides",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#24b57c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-1",
    cx: 60,
    cy: 60,
    r: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_2",
    "data-name": "<Path>",
    className: "cls-2",
    points: "71.33 50.73 71.33 47.78 65.78 42.78 65.78 50.73 71.33 50.73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_Path_3",
    "data-name": "<Path>",
    className: "cls-2",
    x: 43,
    y: 51.84,
    width: 10.56,
    height: 5.56
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Path_4",
    "data-name": "<Path>",
    className: "cls-2",
    x: 61.33,
    y: 51.84,
    width: 21.67,
    height: 5.56
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_Path_5",
    "data-name": "<Path>",
    className: "cls-2",
    x: 72.44,
    y: 62.95,
    width: 10.56,
    height: 5.56
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_6",
    "data-name": "<Path>",
    className: "cls-2",
    points: "71.33 85 71.33 58.5 65.78 58.5 65.78 80 71.33 85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Path_7",
    "data-name": "<Path>",
    className: "cls-2",
    x: 43,
    y: 62.95,
    width: 21.67,
    height: 5.56
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_5",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_8",
    "data-name": "<Path>",
    className: "cls-2",
    points: "54.67 69.61 54.67 72.22 60.22 77.22 60.22 69.61 54.67 69.61"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_9",
    "data-name": "<Path>",
    className: "cls-2",
    points: "60.22 61.84 60.22 40 54.67 35 54.67 61.84 60.22 61.84"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.80a58c00a16f21e67b7ef5f5d0b03b7e.svg";
export { ForwardRef as ReactComponent };